import { createAction, handleActions } from 'redux-actions';

const setActivityPagination = createAction("SCREENS/PROJECT_VIEW/SET_ACTIVITY_PAGINATION");

const defaultState = {
  pageNumber: 1,
  pageSize: 10,
  total: 0,
}

const reducer = handleActions(
  {
    [setActivityPagination]: (state, action) => ({
      ...state,
      ...action.payload
    }),
  },
  defaultState
);

export {
  setActivityPagination,
  reducer,
};
